<script setup>

const props = defineProps({
    isShow: Boolean,
    header: {
        type: String,
        default: () => '',
    },
    content: {
        type: String,
        default: () => '',
    }
});

const emit = defineEmits(['closeTipModal']);

const closeTipModal = (e) => {
    if (e.target === e.currentTarget) {
        emit('closeTipModal')
    }
}

</script>

<template>
    <div class="modal-overlay" v-if="isShow" @click="closeTipModal">
        <div class="modal-content">
            <h4>{{ header }}</h4>
            <div v-html="content"></div>
            <div class="btn default" @click="closeTipModal">Понял</div>
        </div>
        <p class="close" id="close1">[закрыть]</p>
        <p class="close" id="close2">[закрыть]</p>
        <p class="close" id="close3">[закрыть]</p>
    </div>
</template>

<style scoped lang="scss">
    @use '~@/assets/styles/vars' as *;
    .modal-overlay {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(109, 111, 113, 0.5);

        display: flex;
        justify-content: center;
        align-items: center;

        z-index: 20;
    }

    .modal-content {
        position: relative;
        background: white;
        padding: 30px;
        border-radius: 8px;
        max-width: 400px;
        width: 100%;

        display: flex;
        flex-direction: column;
        gap: 15px;

        box-shadow: 0 0 25px 7px rgba(0,0,0, 0.05);
        animation: showTip 0.15s ease-in;
    }

    .modal-content h4 {
        font-size: 20px;
        font-weight: 500;
    }

    .modal-content {
        line-height: 130%;
    }

    .modal-content div {
        display: flex;
        flex-direction: column;
        gap: 10px;
    }

    .btn {
        background: $black;
        max-width: max-content;
    }

    .close {
        color: rgba(255,255,255,0.5);
        font-size: 12px;
        position: absolute;
        mix-blend-mode: overlay;
    }

    #close1 {
        animation: closeText steps(2) 10s infinite;
    }

    #close2 {
        animation: closeText steps(4) 7s infinite;
        animation-delay: 2s;
    }

    #close3 {
        animation: closeText steps(1) 9s infinite;
        animation-delay: 1s;
    }

    @keyframes showTip {
        0% {
            top: -100px;
        }
        100% {
            top: 0;
        }
    }

    @keyframes closeText {
        0% {
            top: 10%;
            left: 10%;
        }
        20% {
            left: 20%;
            top: 80%;
        }
        40% {
            left: 60%;
            top: 30%;
        }
        50%{
            left: 85%;
            top: 85%;
        }
        60% {
            left: 10%;
            top: 10%;
        }
        70% {
            left: 90%;
            top: 95%;
        }
        80% {
            left: 80%;
            top: 10%;
        }
        100% {
            left: 15%;
            top: 85%;
        }
    }

    @media screen and (max-width: 750px) {
        .modal-content {
            max-width: 75%;
        }

        .modal-content h4 {
            font-size: 18px;
        }

        .modal-content {
            font-size: 14px;
        }
    }
</style>